// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "iframe {\n  width: 100%;\n  height: 100vh;\n}", "",{"version":3,"sources":["webpack://./src/app/cp/boards/time-off-cal/time-off-cal.component.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,aAAA;AACD","sourcesContent":["iframe{\n\twidth:100%;\n\theight:100vh;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
